import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Tag } from '@savgroup-front-common/core/src/atoms/Tag';
import { UI_SIZE } from '@savgroup-front-common/constants/src/shared/size';

import { buildDossierSummaryPath } from '../../utils/dossierRoutes';
import type { DossierRow } from '../../types/dossier.types';
import { formatDossierDate } from '../../utils/dossierFormat';
import { getDossierStatutTagVariant } from '../../utils/dossierStatut';
import {
  $Card,
  $CardButton,
  $CardStack,
  $CardTopRow,
  $MetaItem,
  $MetaValue,
  $StatutTagWrap,
} from './DossierCardList.styles';

export interface DossierCardProps {
  dossier: DossierRow;
}

const DossierCard = ({ dossier }: DossierCardProps) => {
  const navigate = useNavigate();

  const handleOpenDossier = useCallback(() => {
    navigate(buildDossierSummaryPath(dossier.fileId));
  }, [dossier.fileId, navigate]);

  return (
    <$CardButton
      type="button"
      onClick={handleOpenDossier}
      data-testid={`dossiers-card-${dossier.numeroDossier}`}
    >
      <$Card>
        <$CardStack>
        <$CardTopRow>
          <$MetaItem>
            <$MetaValue>{dossier.numeroDossier}</$MetaValue>
          </$MetaItem>
          <$MetaItem $alignEnd>
            <$MetaValue>{formatDossierDate(dossier.dateCreation)}</$MetaValue>
          </$MetaItem>
        </$CardTopRow>
        <$MetaItem>
          <$StatutTagWrap>
            <Tag
              variant={getDossierStatutTagVariant(dossier.statut)}
              size={UI_SIZE.MD}
              withoutMargin
              noEllispis
              fluid
            >
              {dossier.statut}
            </Tag>
          </$StatutTagWrap>
        </$MetaItem>
        </$CardStack>
      </$Card>
    </$CardButton>
  );
};

export default DossierCard;
